import { FrontPageImage, FrontPageImageType } from '@/models/common/front-page-image';

export class AssociationFrontPageImages {
    public images: FrontPageImage[] = [];

    constructor(images: FrontPageImage[] = []) {
        this.images = images.map((image) => image.clone());
        this.init();
    }

    get logoImage(): FrontPageImage | undefined {
        return this.images.find((image) => image.type === FrontPageImageType.Logo);
    }

    get first(): FrontPageImage | undefined {
        return this.images.find((image) => image.type === FrontPageImageType.FirstImage);
    }

    set first(value: FrontPageImage | undefined) {
        let image = this.images.find((image) => image.type === FrontPageImageType.FirstImage);
        image = value;
    }

    get second(): FrontPageImage | undefined {
        return this.images.find((image) => image.type === FrontPageImageType.SecondImage);
    }

    set second(value: FrontPageImage | undefined) {
        let image = this.images.find((image) => image.type === FrontPageImageType.SecondImage);
        image = value;
    }

    get third(): FrontPageImage | undefined {
        return this.images.find((image) => image.type === FrontPageImageType.ThirdImage);
    }

    set third(value: FrontPageImage | undefined) {
        let image = this.images.find((image) => image.type === FrontPageImageType.ThirdImage);
        image = value;
    }

    public init(): void {
        const imagesContext = require.context('@/assets/placeholders/association/', false, /(\.jpg|\.png)$/);
        const imagesContextShared = require.context('@/assets/placeholders/shared/', false, /(\.jpg|\.png)$/);

        if (!this.images.some((image) => image.type === FrontPageImageType.Logo)) {
            this.images.push(new FrontPageImage({ type: FrontPageImageType.Logo, url: imagesContext('./whiteBrandLogoDark.png') }));
        }

        if (!this.images.some((image) => image.type === FrontPageImageType.FirstImage)) {
            this.images.push(new FrontPageImage({ type: FrontPageImageType.FirstImage, url: imagesContextShared('./placeholder16x9.png') }));
        }

        if (!this.images.some((image) => image.type === FrontPageImageType.SecondImage)) {
            this.images.push(new FrontPageImage({ type: FrontPageImageType.SecondImage, url: imagesContextShared('./placeholder16x9.png') }));
        }

        if (!this.images.some((image) => image.type === FrontPageImageType.ThirdImage)) {
            this.images.push(new FrontPageImage({ type: FrontPageImageType.ThirdImage, url: imagesContextShared('./placeholder16x9.png') }));
        }
    }
}
